import './styles.scss';
import { DisposalSet, onReadyEach, select, selectAll } from '../../utils';
import { addToMultiParamMap, removeFromMultiParamMap, toMultiParamMap, toURLSearchParams, updateResults } from '../../fragments/layouts/aoc-search-layout/facets';
const gc = new DisposalSet();
const initCategoryListFacet = (facetEl, pageParam) => {
  const parentFormEl = facetEl.closest('form');
  const searchLayoutEl = facetEl.closest('.aoc-search-layout');
  if (!parentFormEl || !searchLayoutEl) return;
  const facetParamName = select(parentFormEl, 'input.facet-parameter-name');
  const listItemCheckboxEls = selectAll(facetEl, '.aoc-category-list-facet__item input[type="checkbox"]');
  for (const checkboxEl of listItemCheckboxEls) {
    gc.register(checkboxEl).addListener('change', e => {
      const multiParamMap = toMultiParamMap(new URLSearchParams(window.location.search));
      const value = checkboxEl.value;
      if (checkboxEl.checked) {
        addToMultiParamMap(multiParamMap, facetParamName.value, value);
      } else {
        removeFromMultiParamMap(multiParamMap, facetParamName.value, value);
      }
      removeFromMultiParamMap(multiParamMap, pageParam, null);
      const params = toURLSearchParams(multiParamMap);
      const nextUrl = `${window.location.pathname}?${params}`;
      updateResults(searchLayoutEl, nextUrl, pageParam);
    });
  }
};
export const reinit = (parentEl, replacements, pageParam) => {
  gc.disposeAll();
  const facetEls = selectAll(parentEl, '.aoc-category-list-facet');
  for (let i = 0; i < facetEls.length; i++) {
    const facetEl = facetEls[i];
    const replacementFacetEl = replacements[i];
    if (replacementFacetEl) {
      facetEl.replaceWith(replacementFacetEl);
      initCategoryListFacet(replacementFacetEl, pageParam);
    }
  }
};
onReadyEach('.aoc-category-list-facet', facetEl => {
  initCategoryListFacet(facetEl, 'start');
});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}